// 目前页面比较少，就不先拆分路由了，直接在routes.js中维护。
const updateRoutes = [
  {
    path: '/',
    name: 'mainPage',
    redirect: '/homePage',
    component: () => import('@pages/mainPage'),
    // 子路由配置
    children: [
      {
        path: 'homePage',
        name: 'homePage',
        component: () => import('@pages/homePage'),
      },
      {
        path: 'chatPart/:id',
        name: 'chatPart',
        component: () => import('@pages/chatPart/chatPage'),
      },
      
    ],
  },
]

export default updateRoutes
